export const CASH_CLOSURES_PAGE_SIZE_STORAGE_KEY = 'cash_closures_page_size';

/** Filtro de arqueo en historial de cierres. */
export type CashDifferenceFilter = 'all' | 'exact' | 'shortage' | 'surplus' | 'any';

export type CashHistorySort = 'closed_desc' | 'shortage_desc' | 'surplus_desc';

export type CashOperatorFilter = 'all' | string;

export const CASH_DIFFERENCE_FILTER_OPTIONS: Array<{ value: CashDifferenceFilter; label: string }> = [
  { value: 'all', label: 'Todos' },
  { value: 'exact', label: 'Sin diferencia' },
  { value: 'shortage', label: 'Faltante' },
  { value: 'surplus', label: 'Sobrante' },
  { value: 'any', label: 'Con diferencia' },
];

export const CASH_HISTORY_SORT_OPTIONS: Array<{ value: CashHistorySort; label: string }> = [
  { value: 'closed_desc', label: 'Más reciente' },
  { value: 'shortage_desc', label: 'Mayor faltante' },
  { value: 'surplus_desc', label: 'Mayor sobrante' },
];

export const CASH_OPERATOR_FILTER_ALL = 'all' as const;

export type CashHistoryRangePreset = '7d' | '30d' | '90d' | 'custom';

export const CASH_HISTORY_PRESET_CHIPS: { id: CashHistoryRangePreset; label: string }[] = [
  { id: '7d', label: '7 días' },
  { id: '30d', label: '30 días' },
  { id: '90d', label: '90 días' },
  { id: 'custom', label: 'Personalizado' },
];
